import React from 'react';

const ClockIcon = ({className}) => (
  <svg className={className} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path style={{fillRule: "evenodd", clipRule: "evenodd", fill: "black", fillOpacity: "0.01", strokeWidth: "1.41935"}} d="M21.9999 14.8441C25.9522 14.8441 29.1558 18.0478 29.1558 22C29.1558 25.9522 25.9522 29.1559 21.9999 29.1559C18.0479 29.1559 14.844 25.9522 14.844 22C14.844 18.0478 18.0479 14.8441 21.9999 14.8441Z" />
    <path style={{fillRule: "evenodd", clipRule: "evenodd", fill: "black", fillOpacity: "0.01",strokeWidth: "0.709677"}} d="M21.9999 22.0002H21.3494V17.4464H21.9999V22.0002Z" />
    <path style={{fillRule: "evenodd", clipRule: "evenodd", fill: "black", fillOpacity: "0.01",  strokeWidth: "0.709677"}} d="M25.3988 23.6606L25.1078 24.2424L21.2046 22.2909L21.4956 21.7089L25.3988 23.6606Z"/>
  </svg>
);

export default ClockIcon;
